export const colors = {
	primary: '#0282FB',
	secondary: '#02EF51',
	tertiary: '#7AADDD',
	black: '#000000',
	slate: '#3f3d56',
	lightGrey: '#f7f7f7',
	grey: '#f2f2f2',
	white: '#ffffff',
	tomato: '#E81224'
};

export const fonts = {
	monospace: "'JetBrains Mono', monospace",
	sansSerif: "'Gothic A1', sans-serif"
};

const theme = { colors, fonts };
export default theme;
